import { SortType } from '../hooks/infiniteScroll'

export const getSortParamRequest = (model?: SortType[]) => {
  return model?.length ? model.map(item => `${item.sortKey || item.field},${item.sort}`) : undefined
}
